import Vue from 'vue';

Vue.component('user-index', () =>
    import(/* webpackChunkName: 'user-index' */ './user-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/user/index.js